// extracted by mini-css-extract-plugin
export default {"jumbotron":"Jumbotron_jumbotron__jKZ9W"};